<template>
    <div>
      <section class="invoice-preview-wrapper">
        <BRow v-if="invoice" class="invoice-preview" >
          <!-- Col: Left (Invoice Container) -->
          <BCol cols="12" xl="9" md="8">
            <BCard no-body class="invoice-preview-card">
              <!-- Header -->
              <BCardBody class="invoice-padding pb-0">

                <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                  <!-- Header: Left Content -->
                  <div>
                    <div class="logo-wrapper">
                      <BImg :src="appLogoImage" width="50" />
                      <h3 class="text-primary invoice-logo"> {{ appName }} </h3>
                    </div>
                    <p class="card-text mb-0"> {{ invoice.settings_company_name }} </p>
                    <p class="card-text mb-0"> {{ invoice.settings_cif }} </p>
                    <p class="card-text mb-25"> {{ invoice.settings_address }}</p>
                    <p class="card-text mb-25">{{invoice.settings_postal_code}} - {{invoice.settings_city}}</p>
                    <p class="card-text mb-0"> {{invoice.settings_province}}, {{invoice.settings_country}} </p>
                    <p class="card-text mb-0"> {{ invoice.settings_phone }} </p>
                  </div>

                  <!-- Header: Right Content -->
                  <div class="mt-md-0 mt-2"> 
                    <h4 class="invoice-title"> <span class="invoice-number">{{ invoice.name}}</span> </h4>

                    <div class="invoice-date-wrapper" v-if="invoice.n_corrective_invoice">
                      <p class="invoice-date-title"> Rectifica: </p>
                      <p class="invoice-date"> {{ invoice.invoice.name }} </p>
                    </div>
                    <div class="invoice-date-wrapper" v-if="invoice.n_corrective_invoice">
                      <p class="invoice-date-title"> Motivo: </p>
                      <p class="invoice-date"> {{ invoice.correcting_reason.name }} ({{ invoice.correcting_reason.code }}) </p>
                    </div>
                    <div class="invoice-date-wrapper" v-if="invoice.n_corrective_receipt">
                      <p class="invoice-date-title"> Rectifica: </p>
                      <p class="invoice-date"> {{invoice.invoice.name }} </p>
                    </div>
                    <div class="invoice-date-wrapper">
                      <p class="invoice-date-title"> {{ $t('Emit Date') }}: </p>
                      <p class="invoice-date"> {{ formatDate(invoice.emit_date) }} </p>
                    </div>
                    <div class="invoice-date-wrapper" v-if="invoice.payment_date">
                      <p class="invoice-date-title"> {{ $t('Due Date') }}: </p>
                      <p class="invoice-date"> {{ invoice.payment_date ? formatDate(invoice.payment_date) : '' }} </p>
                    </div>
                  </div>
                </div>
              </BCardBody>

              <!-- Spacer -->
              <hr class="invoice-spacing">

              <!-- Invoice Client & Payment Details -->
              <BCardBody v-if="invoice" class="invoice-padding pt-0">
                <BRow class="invoice-spacing">

                  <!-- Col: Invoice To -->
                  <BCol cols="8" class="p-0">
                    <h6 class="mb-1"> <b>{{ $t('Invoice To') }}:</b> </h6>
                    <p class="font-weight-normal"> {{ invoice.customer_billing_full_name }} </p>
                    <p > {{ invoice.customer_billing_nif }}</p>
                    <p v-if="invoice.customer_billing_address!=null && invoice.customer_billing_postal_code!=null && invoice.customer_billing_city!=null && invoice.customer_billing_province!=null  && invoice.customer_billing_country!=null " > {{ invoice.customer_billing_address }}, {{ invoice.customer_billing_postal_code }}, {{ invoice.customer_billing_city }}, {{ invoice.customer_billing_province }},  {{ invoice.customer_billing_country }} </p>
                  </BCol>

                  <BCol cols="4" class="p-0">
                    <h6 class="mb-1"> <b>Método de pago:</b> </h6>
                    <p> {{ invoice.payment_method }}  </p>
                    <p> {{ (invoice.payment_method == "Domiciliaciones de pago" || invoice.payment_method == "Transferencias bancarias") ? ( invoice.bank_account_iban) :  ''}} </p>
                    <p> {{ (invoice.payment_method == "Domiciliaciones de pago" || invoice.payment_method == "Transferencias bancarias") ? ( invoice.bank_account_swift) :  ''}} </p>
                  </BCol>
                </BRow>
              </BCardBody>

              <!-- Invoice Description: Table -->
              <BTableLite responsive :items="invoice.items" :fields="(invoice.customer_pit) ? fieldsIRPF : fields">
                <template #cell(item)="data">
                  <BCardText class="font-weight-bold mb-25"> {{ data.item.name }} </BCardText>
                  <BCardText class="text-nowrap text-muted"> <small>{{ data.item.observations }} </small></BCardText>
                </template>
                <template #cell(cantidad)="data">{{ data.item.quantity}}</template>
                <template #cell(importe)="data">{{ formatCurrency(data.item.amount) }}</template>
                <template #cell(descuento)="data"> {{ data.item.discount + '%'}} </template>
                <template #cell(iva)="data"> {{ data.item.vat + "%" }} </template>
                <template #cell(irpf)="data"> {{ data.item.pit? data.item.pit  + '%' : '0%' }} </template>
                <template #cell(total)="data"> {{ formatCurrency(data.item.total) }} </template>
              </BTableLite>

              <hr class="invoice-spacing">

              <!-- Invoice Description: Total -->
              <BCardBody class="invoice-padding pb-0" style="margin-bottom:23.2px;">
                <BRow>

                  <!-- Col: Sales Persion -->
                  <BCol cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1" >
                    <BCardText class="mb-0">
                      <span class="font-weight-bold">{{ $t('User') }}:</span>
                      <span class="ml-75">{{ invoice.user_full_name }}</span>
                    </BCardText>
                  </BCol>

                  <!-- Col: Total -->
                  <BCol cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Subtotal') }}: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.subtotal) }} </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Discount') }}: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.discounts) }} </p>
                      </div>

                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> Base imponible: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.taxableBase) }} </p>
                      </div>
                      <div class="invoice-total-item" v-for="v of invoice.vats">
                        <p class="invoice-total-title"> IVA {{ v.value }}% </p>
                        <p class="invoice-total-amount"> {{formatCurrency(v.price)}} </p>
                      </div>
                      <div class="invoice-total-item" v-if="!(invoice.pits.length==0) && invoice.group.pit" v-for="p of invoice.pits" >
                        <p class="invoice-total-title"> IRPF {{ p.value }}% </p>
                        <p class="invoice-total-amount"> {{formatCurrency(p.price)}} </p>
                      </div>
                      <hr class="my-50">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title"> {{ $t('Total') }}: </p>
                        <p class="invoice-total-amount"> {{ formatCurrency(invoice.amount) }} </p>
                      </div>
                    </div>
                  </BCol>
                </BRow>
              </BCardBody>

              <!-- Spacer -->

              <div v-if="invoice.note" >
                <hr class="invoice-spacing mt-0">
                <!-- Note -->
                <BCardBody class="invoice-padding pt-0">
                  <span class="font-weight-bold">Nota: </span>
                  <span>{{ invoice.note }}</span>
                </BCardBody>
              </div>
            </BCard>
          </BCol>

          <!-- Right Col: Card -->
          <BCol cols="12" md="4" xl="3" class="invoice-actions" >
            <BCard>
              <BButton v-if="parent=='invoices-view'" v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" class="mb-75" block @click="getPDF(invoice.id, invoice.n_invoice, invoice.n_ticket, invoice.n_corrective_invoice, invoice.n_corrective_ticket, 'download')" > {{ $t('Download') }}</BButton>
              <BButton v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" class="mb-75" block @click="getPDF(invoice.id, invoice.n_invoice, invoice.n_ticket, invoice.n_corrective_invoice, invoice.n_corrective_ticket, 'print')" > Imprimir </BButton>
              <BButton v-if="(invoice.n_invoice || invoice.n_corrective_invoice) && (invoice.account && invoice.account.emit_face)  " variant="outline-primary" class="mb-75" block @click="exportData(`/create-e-invoice/${invoice.id}`, null, invoice.name, 'XSIG')" > FacturaE </BButton>
              <BButton v-if="isEditable(invoice.is_editable)" v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="primary" class="mb-75" block :to="{ name: 'invoices-edit', params: { id: $route.params.id } }" > {{ $t('Edit') }} </BButton>
              <BButton variant="outline-primary" class="mb-75" block @click="confirmInvoice" v-if="parent=='tpv'">Aceptar</BButton>
              <CheckboxValidated vsName="send_email" :vsModel.sync="checkSendEmail" vsLabel="Enviar correo electrónico de la factura" v-if="parent=='tpv'"></CheckboxValidated>
            </BCard>
          </BCol>
        </BRow>

      </section>

      <!-- Charge section -->
      <section v-if="invoice && parent=='invoices-view'">
        <BRow>
            <BCol cols="12" xl="9" md="8">
                <BCard>
                    <BRow class="mb-2">
                        <BCol>
                            <h3>Cobros y abonos asociados</h3>
                        </BCol>
                    </BRow>
                    <BRow>
                        <BCol v-if="invoice.total_charge != invoice.amount">
                            <BButton variant="outline-primary" @click="openChargeModal">
                                <FeatherIcon icon="PlusIcon" class="mr-50" />
                                <span class="align-middle">Añadir</span>
                            </BButton>
                        </BCol>
                        <BCol cols="12" class="mt-2">
                          <BTable :items="invoice.charges" show-empty empty-text="Ningún cobro o abono asociado" :fields="chargeFields" v-if="invoice">
                            <template #cell(amount)="data">
                              {{ formatCurrency(data.item.amount) }}
                            </template>

                            <template #cell(payment_date)="data">
                              {{ formatDate(data.item.payment_date) }}
                            </template>

                            <template #cell(actions)="data">
                              <BButton variant="flat-success" class="btn-icon" @click="exportData('charge/export', { id: data.item.id }, 'pago_'+invoice.name, 'PDF')">
                                <FeatherIcon size="18" icon="DownloadIcon" />
                              </BButton>
                              <BButton v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger" class="btn-icon" @click="deletePopupAxios(data.item.id, `charges/${data.item.id}`)">
                                <FeatherIcon size="18" icon="TrashIcon" />
                              </BButton>

                              
                            </template>
                          </BTable>
                        </BCol>
                    </BRow>
                </BCard>
            </BCol>
        </BRow>

        <!-- Charge modal -->
        <BModal hide-footer ref="chargeModal" cancel-variant="outline-secondary" centered title="Añadir cobro o abono" no-close-on-backdrop>
            <BForm @submit.prevent="addCharge">
                <BCol class="mb-1">
                  <label for="payment_method">Método de pago</label>
                  <VueSelect id="payment_method" v-model="charge.payment_method_id" :options="paymentMethodsOptions" label="name" :reduce="pay => pay.id" required v-if="paymentMethodsOptions" />
                </BCol>
                <BCol v-if="cashes && showCashes">
                  <label >Caja</label>
                  <VueSelect v-model="charge.cash_id" :reduce="cash => cash.id" :options="cashes" label="name" id="payment-method" class="payment-selector" :clearable="false"/>
                </BCol>    
                <DatepickerValidated vsName="Fecha de pago" :vsModel.sync="charge.payment_date"/>
                <BCol>
                  <BFormGroup label="Importe" label-for="charge_amount">
                    <!-- <BFormInput type="number" step="0.01" id="charge_amount" :max=" (invoice.amount > 0) ?  parseFloat(invoice.amount - invoice.total_charges).toFixed(2) : 0" :min="(invoice.amount > 0) ? 0 : parseFloat(invoice.amount + Math.abs(invoice.total_charges)).toFixed(2)" v-model="charge.amount" required /> -->
                    <BFormInput type="number" step="0.01" id="charge_amount" :disabled="(invoice.specific_status.owe == 0) ? true : false " :max=" (invoice.specific_status.owe > 0) ?  parseFloat(invoice.specific_status.owe).toFixed(2) : 0" :min="(invoice.specific_status.owe > 0) ? 0 : parseFloat(invoice.specific_status.owe).toFixed(2)" v-model="charge.amount" required />

                  </BFormGroup>
                  <p><small class="text-muted">RECUERDA: Los cobros son positivos y los abonos negativos.</small></p>
                </BCol>
                <BCol class="d-flex justify-content-end mt-2">
                    <BButton variant="danger" class="mr-1" @click="closeChargeModal">Cancelar</BButton>
                    <BButton variant="primary" type="submit" id="submitbutton">Añadir</BButton>
                </BCol>
            </BForm>
        </BModal>
      </section>

      <iframe id="iframe" width="600px" scrolling="auto" height="1000px" 
        frameborder="1"
        style="border: 0rem none #ffffff;" name="national-campaign" 
        marginheight="0rem" marginwidth="0rem">
      </iframe>
    </div>
  </template>

<script>
import { BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle, BImg, BCardHeader, BCardTitle, BModal, BForm, BFormGroup, BFormInput, BTable } from 'bootstrap-vue'
import { ref, onUnmounted, computed, watch } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import store from '@/store'
import popups from '@/hooks/popups';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import VSelectValidated from '@/components/forms/vSelectValidated.vue'
import axios from '@axios'
import { VueSelect } from 'vue-select'
import ability from '@/libs/acl/ability'
import dateUtils from '@/hooks/dateUtils'
import currency from '@/utils/currency'
import exportUtils from '@/hooks/exportUtils'
import { getInvoice, downloadInvoice, downloadTicket } from '@/composables/invoiceService'
import { getPaymentMethods } from '@/composables/paymentMethodService'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import { sendEmail } from '@/composables/invoiceService'

export default {
    components: { BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, Logo, BImg, BCardHeader, BCardTitle, BModal, BForm, BFormGroup, BFormInput, NumberInputValidated, VSelectValidated, BTable, VueSelect, DatepickerValidated, CheckboxValidated},
    directives: { Ripple,'b-toggle': VBToggle},
    props: ['parent'],
    setup() {
        const { exportData } = exportUtils()
        const { formatCurrency } = currency()
        const { formatDate } = dateUtils()
        const { appName, appLogoImage } = $themeConfig.app
        const INVOICE_MODULE = 'invoices'
        const chargeDetails = ref({})
        const user = JSON.parse(localStorage.getItem('userData'))
        const invoice = ref(null)
        const { errorToast, successToast, deletePopupAxios } = popups()
        const fieldsIRPF=['item', 'cantidad', 'importe', 'descuento', 'iva','irpf', 'total']
        const fields=['item', 'cantidad', 'importe', 'descuento', 'iva', 'total']
        const paymentMethodsOptions = ref([])
        const chargeModal = ref(null)
        const cashes=ref(null)
        const showCashes=ref(false)
        const charge = ref({
          payment_method_id: null,
          amount: null,
          cash_id:null,
          payment_date: new Date(Date.now()).toISOString(),
        })
        const chargeFields = ref([
          { key: 'payment_method.name', label: 'Método de pago' },
          { key: 'amount', label: 'Importe' },
          { key: 'payment_date', label: 'Fecha' },
          { key: 'actions', label: 'Acciones' }
        ])
        const checkSendEmail=ref(false)


        /**
         * Comprobación si se puede modificar una factura no siendo superadministrador
         * @param {boolean} is_editable 
         */
        const isEditable = function(is_editable) {
          if(user.role == "Superadministrador") return true
          if(ability.can('write', 'invoice') && ability.can('create', 'invoice')) return true
          if(is_editable && ability.can('create', 'invoice')) return true
          return false
        }

        // Métodos
        const getPDF= async function (invoiceId, idFac, idTic, idRFac, idRTic, action ) {
          let id

          if (idFac || idRFac) {
            idRFac ? id=idRFac : id=idFac

            let response = await downloadInvoice({idRC: invoiceId, id: id})
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = invoice.value.name+'.pdf'

            if (action=="print") {
              printInvoice(link)
            } else {
              toDownloadInvoice(link)
            }

          } else {
            idRTic ? id=idRTic : id=idTic

            let response = await downloadTicket({idRC: invoiceId, id: id})
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)

              link.download = invoice.value.name

            if (action=="print") {
              printInvoice(link)
            } else {
              toDownloadInvoice(link)
            }

          }
        }

        const printInvoice = (link_print) => {
            let iframe = document.getElementById("iframe"); 
            let newWindow = window.open(link_print.href, 'Dynamic Popup', 'height=' + iframe.getAttribute('height') + ', width=' + iframe.getAttribute('width')  + 'scrollbars=auto, resizable=no, location=no, status=no');
            setTimeout(function() {
              newWindow.focus();
              newWindow.print();
            }, 100);
          }

        /**
         * Enviar correo electrónido con la factura
         */

         const sendInvoiceEmail= async function (studentId, invoiceId) {
          let response = await sendEmail({idST: studentId, idRC: invoiceId})
            if (response.data.success) {
              router.push({ name: 'tpv' })
            } else {
              errorToast("Error enviando correo electrónico")

            }
        }

        /**
        * Aceptar cambios de la factura
        * @returns void
        */
        const confirmInvoice = function(){
          if (checkSendEmail.value) {
          sendInvoiceEmail(invoice.value.student_id ?? invoice.value.account_id, invoice.value.id)
          } else {
            router.push({ name: 'tpv' })
          }
        }

        const toDownloadInvoice = (link_download) => {
          link_download.click()
        }

        const fetchData = async function () {
          let response = (await getInvoice({ id: router.currentRoute.params.id }))
          invoice.value = response.data.invoice        
        }

        const fetchPaymentMethods = async function () {
          paymentMethodsOptions.value = (await getPaymentMethods()).data
        }

        fetchData()
        fetchPaymentMethods()

        axios.get('cashes').then(response => {
          cashes.value=response.data.cashes
        })

        /**
         * Abrir modal de pagos
         */
        const openChargeModal = function(){
          charge.value.invoice_id = router.currentRoute.params.id
          charge.value.amount = invoice.value.specific_status.owe.toFixed(2)
          chargeModal.value.show()
        }

        /**
         * Cerrar modal de pagos
         */
        const closeChargeModal = function(){
          chargeModal.value.hide()
          charge.value = {
            payment_method_id: null,
            cash_id:null,
            amount: null,
            payment_date: new Date(Date.now()).toISOString()
          }
        }

        /**
         * Añadir pago
         */
        const addCharge = function(){
          if(charge.value.amount==0){
            errorToast("El cobro/abono no puede ser 0")
            return
          }

          if(!charge.value.payment_method_id){
                errorToast("Select a charge method")
                return
          }

          if(charge.value.payment_method_id==1 && !charge.value.cash_id){
              errorToast("Select a cash")
              return
          }

            document.getElementById('submitbutton').disabled=true;
            axios.post('charges', charge.value).then(response => {
                 document.getElementById('submitbutton').disabled=false;

                if (response.data.success) {
                  successToast('Charge created')
                  closeChargeModal()
                  fetchData()
                } else {
                  errorToast(response.data.msg)
                } 
                
            })
            .catch(error => {
                document.getElementById('submitbutton').disabled=false;
                errorToast("Error on create charge")
            })
        }

        watch(charge, () => {
          if (charge.value.payment_method_id==1) {
          showCashes.value=true
        } else {
          showCashes.value=false
        }
        }, {deep:true})

        return {
            deletePopupAxios,
            ability,
            chargeFields,
            chargeModal,
            openChargeModal,
            closeChargeModal,
            addCharge,
            paymentMethodsOptions,
            charge,
            chargeDetails,
            appLogoImage,
            invoice,
            appName,
            getPDF,
            fields,
            fieldsIRPF, 
            showCashes,
            cashes, 
            formatDate,
            formatCurrency,
            isEditable,
            exportData,
            fetchData,
            checkSendEmail,
            confirmInvoice
          }
    },
}
</script>

  <style lang="scss" scoped>
  @import "~@core/scss/base/pages/app-invoice.scss";
  </style>

  <style lang="scss">
  @media print {

    // Global Styles
    body {
      background-color: transparent !important;
    }
    nav.header-navbar {
      display: none;
    }
    .main-menu {
      display: none;
    }
    .header-navbar-shadow {
      display: none !important;
    }
    .content.app-content {
      margin-left: 0;
      padding-top: 32px !important;
    }
    footer.footer {
      display: none;
    }
    .card {
      background-color: transparent;
      box-shadow: none;
    }
    .customizer-toggle {
      display: none !important;
    }

    // Invoice Specific Styles
    .invoice-preview-wrapper {
      .row.invoice-preview {
        .col-md-8 {
          max-width: 100%;
          flex-grow: 1;
        }

        .invoice-preview-card {
          .card-body:nth-of-type(2) {
            .row {
                > .col-12 {
                max-width: 50% !important;
              }

              .col-12:nth-child(2) {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
                margin-top: 0 !important;
              }
            }
          }
        }
      }

      // Action Right Col
      .invoice-actions {
        display: none;
      }
    }
  }
  </style>
